import * as React from 'react';
import ChartRender from './ChartRender';
import { lineRender, lineRender2, lineRender3 } from './chartRender/lineRender';

export default class LineChart extends React.Component {
    static indentify = 'line_chart';
    render() {
        return (
            <div className="full-height full-width">
                <ChartRender chartRender={this.props.type === 2 ? lineRender2 : this.props.type === 3 ? lineRender3 : lineRender} {...this.props} />
            </div>
        );
    }
}
